import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/CreateManualRepository'


class CreateManualBloc {

    detailChannel = new Subject();
    createChannel = new Subject();
    hukdisListChannel = new Subject();
    employeeListChannel = new Subject();
    repository = new UpdateRepository()

    constructor() {
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.createChannel.next({status: apiResponse.INITIAL})        
        this.hukdisListChannel.next({status: apiResponse.INITIAL})        
        this.employeeListChannel.next({status: apiResponse.INITIAL})        
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }

    fetchEmployeeList = async (query) => {
        try {
            this.employeeListChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEmployeeList(query).then((result) => {
                this.employeeListChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.employeeListChannel.next({status: apiResponse.ERROR, data: error})
            })  
        } catch (error) {
            console.log('rxjs', error)
        }
    }
    fetchHukdisList = async (query) => {
        try {
            this.hukdisListChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchHukdisList(query).then((result) => {
                this.hukdisListChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.hukdisListChannel.next({status: apiResponse.ERROR, data: error})
            })  
        } catch (error) {
            console.log('rxjs', error)
        }
    }
}

export default CreateManualBloc